<ng-template #filterIcon>
  <svg
    class="w-3 h-3 text-gray-400"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z"
    />
  </svg>
</ng-template>

<!-- Grower Table -->
<section
  class="h-full bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden"
>
  <!-- Grower Table Container -->
  <!-- Table Top: Search, User List, Columns Selection and Download Button -->
  <div
    class="h-[10%] w-full flex flex-col md:flex-row items-center justify-between gap-2 p-2 mt-2 my-1"
  >
    <!-- Table Title -->
    <div
      class="flex flex-row items-baseline gap-2 ml-2 whitespace-nowrap overflow-x-auto"
    >
      <h2
        class="flex-1 text-base 3xl:text-xl font-semibold text-gray-500 dark:text-gray-400"
      >
        Claimed Fields
      </h2>
      <!-- Filter Chip List -->
      @if (filterChipList().length > 0) {
        <span
          class="text-sm 3xl:text-base font-semibold text-gray-500 dark:text-gray-400"
          >Active Filters:
        </span>
        <div class="overflow-x-auto custom-scrollbar">
          <div
            class="flex flex-row items-center gap-2 rounded-lg bg-transparent"
          >
            @for (filterChip of filterChipList(); track filterChip.column) {
              <div
                class="flex flex-row items-center gap-2 px-4 rounded-lg border border-blue-50 bg-blue-50 text-blue-900 dark:shadow-black dark:shadow-sm dark:bg-blue-900 dark:border-blue-700 dark:text-gray-50"
              >
                <span class="text-xs 3xl:text-sm font-medium"
                  >{{ getColumnLabel(filterChip.column) }}:
                  {{
                    formatColumnValueWithoutField(
                      filterChip.column,
                      filterChip.value
                    )
                  }}</span
                >
                <button
                  class="flex flex-row items-center justify-center hover:text-blue-700 dark:hover:text-gray-200"
                  (click)="
                    onSelectedColumnFilterChange(filterChip.column, null)
                  "
                  type="button"
                >
                  <svg
                    class="w-4 h-4"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18 17.94 6M18 18 6.06 6"
                    />
                  </svg>
                </button>
              </div>
            }
          </div>
        </div>
        <button class="flex justify-center items-baseline">
          <span
            class="text-xs 3xl:text-sm font-medium text-gray-700 hover:underline hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 cursor-pointer"
            (click)="clearAllFilters()"
            >Clear All</span
          >
        </button>
      }
    </div>
    <!-- Search & Column Filters & Download -->
    <div
      class="relative max-h-16 min-h-10 flex flex-col md:flex-row items-stretch justify-end gap-2 h-full"
    >
      <button
        #dropdownButtonColumnList
        id="actionsDropdownButton"
        class="w-full h-full md:w-auto flex items-center justify-center py-1 px-2 3xl:py-2 3xl:px-4 text-xs 3xl:text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
        type="button"
        (click)="columnListDropdownOpen = !columnListDropdownOpen"
      >
        <svg
          class="h-4 w-4 3xl:h-5 3xl:w-5 mr-1 3xl:mr-2 text-gray-400"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            d="M10.83 5a3.001 3.001 0 0 0-5.66 0H4a1 1 0 1 0 0 2h1.17a3.001 3.001 0 0 0 5.66 0H20a1 1 0 1 0 0-2h-9.17ZM4 11h9.17a3.001 3.001 0 0 1 5.66 0H20a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H4a1 1 0 1 1 0-2Zm1.17 6H4a1 1 0 1 0 0 2h1.17a3.001 3.001 0 0 0 5.66 0H20a1 1 0 1 0 0-2h-9.17a3.001 3.001 0 0 0-5.66 0Z"
          />
        </svg>
        Columns
      </button>
      <!--Columns Dropdown List -->
      <div
        #dropdownMenuColumnList
        class="absolute right-10 top-12 z-10 w-48 p-3 bg-white rounded-lg shadow dark:bg-gray-700"
        [class.hidden]="!columnListDropdownOpen"
        [class.block]="columnListDropdownOpen"
      >
        <h6
          class="mb-3 text-xs 3xl:text-sm font-medium text-gray-900 dark:text-white"
        >
          Display Columns
        </h6>
        <ul
          class="space-y-2 text-xs 3xl:text-sm"
          aria-labelledby="filterDropdownButton"
        >
          @for (
            entry of columnVisibility() | keyvalue: originalOrder;
            track entry.key
          ) {
            @if (entry.value !== undefined && entry.value !== null) {
              <li class="flex items-center">
                <input
                  [checked]="entry.value === true"
                  (change)="toggleColumnVisibility(entry.key)"
                  type="checkbox"
                  value=""
                  class="w-4 h-4 bg-gray-100 border-gray-300 rounded text-primary-600 focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                />
                <label
                  for="apple"
                  class="ml-2 text-xs 3xl:text-sm font-medium text-gray-900 dark:text-gray-100"
                  >{{ getColumnLabel(entry.key) }}</label
                >
              </li>
            }
          }
        </ul>
      </div>
      <!-- Download Button -->
      <button
        title="Download current table as CSV (includes active filters and visible columns only)"
        class="h-full bg-blue-600 text-white px-2 py-1 3xl:px-4 3xl:py-2 rounded-lg hover:bg-blue-700 w-full md:w-auto flex items-center gap-1 3xl:gap-2 justify-center focus:outline-none"
        (click)="downloadData()"
      >
        <p class="whitespace-nowrap text-xs 3xl:text-sm font-medium">
          DOWNLOAD FIELDS
        </p>
      </button>
    </div>
  </div>

  <!-- Table Contents -->
  <div class="h-[70%] overflow-auto px-2 pt-1 custom-scrollbar" #tableContainer>
    <!-- Table -->
    <table
      class="w-full text-xs 3xl:text-sm text-left text-gray-500 dark:text-gray-400"
    >
      <!-- Table Head -->
      <thead
        class="relative text-xs text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
      >
        <tr>
          @for (
            column of columnVisibility()
              | keyvalue: originalOrder
              | visibleColumns;
            track column.key;
            let i = $index;
            let count = $count
          ) {
            <th class="px-4 py-3 normal-case text-nowrap">
              <div class="flex flex-row gap-1 items-center">
                <span class="uppercase">
                  {{ getColumnLabel(column.key) }}
                </span>
                <div>
                  <!-- Flip direction if the last 2 column -->
                  <app-dropdown
                    [overwriteStyle]="'min-w-44'"
                    [useSearch]="true"
                    [dropdownPlacement]="'bottom'"
                    [dropdownXPlacement]="i >= count - 2 ? 'left' : 'right'"
                    [customButtonTemplate]="filterIcon"
                    [options]="columnValueFilterOptions()[column.key] ?? []"
                    [keyField]="'key'"
                    [labelField]="'label'"
                    [outputField]="'key'"
                    [selectedKey]="
                      selectedColumnFilterValue()[column.key] ?? null
                    "
                    (selectedKeyChange)="
                      onSelectedColumnFilterChange(column.key, $event)
                    "
                  />
                </div>
              </div>
            </th>
          }
        </tr>
      </thead>
      <!-- Table Body -->
      <tbody>
        <!-- Render table contents row by row -->
        @for (
          claimedField of paginatedData();
          let i = $index;
          track claimedField.id
        ) {
          <!-- Change Styles when selected -->
          <tr
            #tableRow
            [class]="
              userFieldSelectedId() === claimedField.id ?
                'border-b dark:border-gray-700 bg-gray-200 text-black dark:bg-blue-700 cursor-pointer'
              : 'border-b text-gray-900 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer'
            "
            (click)="
              this.userFieldService.setSelectedUserFieldId(claimedField.id)
            "
          >
            @for (
              column of columnVisibility()
                | keyvalue: originalOrder
                | visibleColumns;
              track column.key
            ) {
              <td
                class="px-4 py-3 font-medium whitespace-pre-line text-nowrap dark:text-white"
                [ngClass]="column.key === 'email' ? 'lowercase' : 'capitalize'"
              >
                {{ renderCell(column.key, claimedField) }}
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
  <!-- Table Footer: Page counts & Pagination -->

  <nav
    class="h-auto flex flex-col md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0 px-4 pb-3"
    aria-label="Table navigation"
  >
    <!-- Page Index and Page Count -->

    <span
      class="text-xs 3xl:text-sm font-normal text-gray-500 dark:text-gray-400"
    >
      Showing
      <!-- start and end indexes (dynamically) -->
      <span class="font-semibold dark:text-white"
        >{{ startIndex() + 1 }} - {{ endIndex() }}</span
      >
      of
      <!-- total index (dynamically) -->
      <span class="font-semibold text-gray-900 dark:text-white">{{
        filteredFields().length
      }}</span>
    </span>

    <!-- Previous and Next Buttons -->
    <ul class="inline-flex items-stretch -space-x-px">
      <!-- Previous Button-->

      <li (click)="previousPage()">
        <!-- Previous Icon in the a link -->

        <a
          class="flex items-center justify-center h-full py-1.5 px-3 ml-0 text-gray-500 bg-white rounded-l-lg cursor-pointer border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
        >
          <span class="sr-only">Previous</span>
          <svg
            class="w-5 h-5"
            aria-hidden="true"
            fill="currentColor"
            viewbox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </a>
      </li>

      <!-- Next Button-->

      <li (click)="nextPage()">
        <!-- Next Icon in the a link -->

        <a
          class="flex items-center justify-center h-full py-1.5 px-3 leading-tight text-gray-500 bg-white rounded-r-lg cursor-pointer border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
        >
          <span class="sr-only">Next</span>
          <svg
            class="w-5 h-5"
            aria-hidden="true"
            fill="currentColor"
            viewbox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </a>
      </li>
    </ul>
  </nav>
</section>
